<template>
  <div class="user-reports">
    <v-card elevation="1">
      <v-card-title class="d-flex justify-center">
        <div>Reports & Exports</div>
      </v-card-title>
      <v-card-text>
        <div class="d-flex justify-center gap5">
          <v-btn
            color="primary"
            @click="onExport('csv')"
          >
            <v-icon class="mr-2">
              mdi-file-delimited-outline
            </v-icon>
            Export to CSV
          </v-btn>
          <v-btn
            color="primary"
            @click="onExport('excel')"
          >
            <v-icon class="mr-2">
              mdi-file-excel-outline
            </v-icon>
            Export to Excel
          </v-btn>
          <!-- <v-btn color="primary" @click="onExport('pdf')">
            <v-icon class="mr-2"> mdi-file-pdf-box </v-icon>
            Export to PDF
          </v-btn> -->
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},

  props: {
    filtersOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: { ...this.filtersOptions },
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      loading: "usersAnalyticsDashboard/getLoading",
      list: "usersAnalyticsDashboard/getExport",
    }),
    // options() {
    //   return {
    //     ...this.filtersOptions,
    //   };
    // },
  },
  watch: {
    // filtersOptions() {
    //   this.fetchData();
    // },
  },
  methods: {
    // fetchData() {
    // },
    onExport(type) {
      this.$store.dispatch("usersAnalyticsDashboard/export", {
        ...this.options,
        type: type,
      });
    },
  },
};
</script>
<style lang="sass" scoped>



// @media only screen and (max-width: 960px)
</style>
